import { gql } from '@apollo/client';

import { MIN_MAX_NUMBER_VALUES_FRAGMENT, MIN_MAX_STRING_VALUES_FRAGMENT } from './common';

export const STANDARD_DELIVERY_DEVICE_HIGHER_CATEGORY_REPORT_FILTERS = gql`
    fragment standardDeliveryDeviceHigherCategoryReportFilters on StandardDeliveryDeviceHigherCategoryReportFilters {
        organizationId
        campaignIds
        adProduct
        startDate {
            ...minMaxStringValuesFragment
        }
        endDate {
            ...minMaxStringValuesFragment
        }
        cpm {
            ...minMaxNumberValuesFragment
        }
        revenue {
            ...minMaxNumberValuesFragment
        }
        deliveryGoal {
            ...minMaxNumberValuesFragment
        }
        lifetimeCompletions {
            ...minMaxNumberValuesFragment
        }
        campaigns {
            id
            name
        }
    }
    ${MIN_MAX_STRING_VALUES_FRAGMENT},
    ${MIN_MAX_NUMBER_VALUES_FRAGMENT}
`;
